module.exports = require('./helpers/bundle-url').getBundleURL('iLkEm') + "logo-dark.eefe0b7f.svg";